// Site script (v2 layout). Images use native loading="lazy" and carousels
// are CSS scroll-snap, so there is no lazyload or slider library.
import consentBar from '../modules/consent-bar';
import { readConsentCookie } from '../modules/consent-manager';
import siteNav from './site-nav';
import carousels from './carousel';
import contactForm from './contact-form';
import showMore from './show-more';

readConsentCookie();

document.addEventListener('DOMContentLoaded', function () {
  siteNav();
  carousels();
  showMore();
  contactForm();
  consentBar();
});
